module.exports = __webpack_public_path__ + "static/img/hotelmeister-logo-winter.1d5589a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/png/hotelmeister-logo-winter.png
// module id = um3t
// module chunks = 0